// Single source for public contact details used by header, footer and quick-contact bar.
// WhatsApp / Telegram buttons render only when a value is set here.

const contacts = {
    phone: {display: '(+374) 33 511 500', href: 'tel:+37433511500'},
    phoneOffice: {display: '(011) 50-00-11', href: 'tel:+37411500011'},
    emailSales: 'sales@cpr.am',
    emailMarketing: 'marketing@cpr.am',
    // e.g. '37433511500' (digits only, international format)
    whatsapp: '',
    // e.g. 'citypremiumrealty' (username without @)
    telegram: '',
    facebook: 'https://www.facebook.com/city.premium.realty',
    instagram: 'https://www.instagram.com/citypremiumrealty',
};

export const whatsappHref = contacts.whatsapp ? `https://wa.me/${contacts.whatsapp}` : null;
export const telegramHref = contacts.telegram ? `https://t.me/${contacts.telegram}` : null;

export default contacts;
